/** "3 of 5" as text, plus a bar (the bar repeats the text; it never carries meaning alone). */
import { useTranslation } from 'react-i18next';

export function CapacityMeter({ used, capacity }: { used: number; capacity: number }) {
  const { t } = useTranslation();
  const pct = capacity > 0 ? Math.min(100, Math.round((used / capacity) * 100)) : 0;
  const over = used > capacity;
  return (
    <span className={`cap${over ? ' over' : used >= capacity ? ' full' : ''}`}>
      <span className="cap-text tnum">{t('schedule.ofCapacity', { n: used, cap: capacity })}</span>
      <span className="cap-bar" aria-hidden="true">
        <i style={{ width: `${pct}%` }} />
      </span>
    </span>
  );
}
